/*
 * Copyright (c) Nexign, JSC, 2020-2021.
 */
/**
 * THe wizard popup to show timeout error
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.11.0
 * @since 1.2.0
 */

import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { createStructuredSelector } from 'reselect';

import { LayoutStyled } from '../../../components/common/Block/Layout';
import { IRootReducer } from '../../../reducers/rootReducer';
import { makeSelectTranslationCommon, makeSelectWizardTranslation } from '../../internationalization/intSelectors';
import ICommonTranslation from '../../internationalization/types/common';
import { IWizardTranslation } from '../../internationalization/types/wizards/wizard';
import ModalPopup, { IModalPopup } from '../../modal/components/ModalPopup';
import { wizardStartAction } from '../wizardActions';
import { EWizardName } from '../wizardConstants';
import { makeSelectWizardName } from '../wizardSelectors';

interface IConnectedProps {
    commonTranslation: ICommonTranslation;
    wizardTranslation: IWizardTranslation;
    wizardName: EWizardName;
}

interface IDispatchProps {
    wizardStart: () => void;
}

type TWizardModalSummary = IModalPopup & IConnectedProps & IDispatchProps;

export const WizardModalTimeout = (props: TWizardModalSummary) => {
    const { commonTranslation, wizardTranslation, ...modalPopupProps } = props;

    const handleOkButtonClick = () => {
        props.onCloseModal();
        props.wizardStart()
    };

    return (
        <ModalPopup
            {...modalPopupProps}
            title={commonTranslation.modal.error}
            onCloseModal={props.onCloseModal}
            onOkButtonClick={handleOkButtonClick}
        >
            <LayoutStyled className='mb-3'>
                {wizardTranslation.wizardModalError.timeout}
            </LayoutStyled>
        </ModalPopup>
    );
};

const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    commonTranslation: makeSelectTranslationCommon(),
    wizardTranslation: makeSelectWizardTranslation(),
    wizardName: makeSelectWizardName(),
});

export const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
    wizardStart: () => dispatch(wizardStartAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(WizardModalTimeout);
